import { render } from "./Trx.vue?vue&type=template&id=92eda880&scoped=true"
import script from "./Trx.vue?vue&type=script&lang=js"
export * from "./Trx.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Public\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92eda880"]])

export default __exports__